<p-sidebar
  [(visible)]="showSidebarState"
  position="right"
  [baseZIndex]="10000"
  (onHide)="closeDetailSider()"
>
  <div
    class="flex justify-content-between flex-column-reverse md:flex-row align-items-center"
  >
    <div>
      <div
        class="text-2xl text-900 mb-4 mt-4 md:mt-0 text-center md:text-left font-semibold md:pr-4"
      >
        {{ title() }}
        @if (rightTopContent || rightTopContentTemplate){
        <ng-container
          *ngTemplateOutlet="rightTopContentTemplate"
        ></ng-container>
        }
      </div>
      @if (description()) {
      <div
        class="flex flex-wrap justify-content-center md:justify-content-start gap-3"
      >
        <p>{{ description() }}</p>
      </div>
      }
    </div>
  </div>
  <br />
  <ng-content></ng-content>
</p-sidebar>
